import React from "react";


const Disclaimer = () => {
  return (
    <>
      <div className="pricing-section-description pricing-description-para">
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          Right Lender is a digital loan matchmaking platform owned and operated
          by <strong>Perukkal 100 Consultancy Private Limited (CIN:
          U66190TZ2024PTC031218).</strong>
        </p>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          We are not a direct lender or a company registered with the Reserve
          Bank of India (RBI). However, we are associated with RBI-registered
          Banks and NBFCs, and we facilitate loan applications through our
          partnerships with top financial institutions including:
        </p>

        <ul className="pricing-bullet-list">
          <li>
            <strong>Banks: HDFC Bank, ICICI Bank, Axis Bank, Kotak
            Mahindra Bank, IndusInd Bank, Bandhan Bank, and more.</strong>
          </li>
          <li>
            <strong>NBFCs: Tata Capital, Piramal Finance, Chola
            Finance, Aditya Birla Capital, and over 65+ RBI-registered Banks &
            NBFCs.</strong>
          </li>
        </ul>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">General Loan Conditions</h4>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          Loan amounts, interest rates (ROI), and eligibility criteria are
          subject to the internal policies of each bank or NBFC. Final approval,
          disbursal amount, and rate of interest may vary based on several
          factors, including: Credit score (CIBIL) Age and location Monthly
          income Employment type Existing liabilities and risk assessment
        </p>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Our Promise</h4>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          At Right Lender, we: Analyse your profile and connect you with the most suitable and
          trusted lenders.
        </p>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          Help you access the best loan offers based on your unique needs and
          eligibility.
        </p>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          Empower you to make the final decision — we bring the offer, you
          decide.
        </p>
      </div>
    </>
  );
};

export default Disclaimer;
